export default __webpack_public_path__ + "static/media/beam.615bb30e.png";